module.exports = __webpack_public_path__ + "img/zhencha.9122e09f.jpg";